import React from 'react';
import PropTypes from 'prop-types';
import { FormInput, FormTextarea } from 'components/form';
import PhotoUpload from 'components/photo-upload';

const InjuredPersonFields = ({ person, index, onChange }) => {
  const update = (partial) => onChange({ ...person, ...partial });

  return (
    <div className="mt-4 pt-4 border-t border-dashed border-gray-300 first:mt-0 first:pt-0 first:border-t-0">
      <p className="text-xs font-bold uppercase tracking-wide text-green-regular mb-2">
        {`Injured person ${index}`}
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-6 gap-x-4">
        <FormInput
          label="Injured person's name"
          colspan={6}
          value={person?.name || ''}
          placeholder="Name (or 'self')"
          handleValue={(id, name) => update({ name })}
        />
      </div>

      <FormTextarea
        label="Description of injuries"
        value={person?.description || ''}
        placeholder="Describe injuries to the best of your ability"
        handleValue={(description) => update({ description })}
      />

      <div className="mt-3">
        <PhotoUpload
          label="Injury photo"
          hint="Optional. Comment on failure if no photo."
          files={person?.photo || []}
          onChange={(files) => update({ photo: files })}
          allowComment
          commentValue={person?.photoComment}
          onCommentChange={(photoComment) => update({ photoComment })}
        />
      </div>
    </div>
  );
};

InjuredPersonFields.propTypes = {
  person: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default InjuredPersonFields;
